import base from "@/store/api/base";

export default {
  async upload({type, files}) {

    const formData = new FormData();
    Array.from(files).forEach((file) => {
      formData.append('files', file);
    })
    formData.append("type", type);
    return base.publicApi(null, {
      path: "/file",
      method: "post",
      data: formData
    });
  },
  async get(file) {
    return base.publicApi(null, {
      path: `/file?key=${file}`,
      method: "get",
    });
  },
  createLinkEmb(file) {
    const path = file && file.path
    let fileName = file && file.fileName
    const host = `${process.env.VUE_APP_API_URL}`.replace("/api", "")
    if (path && `${path}`.startsWith(host)) {
      return path;
    }
    if (!file && path) {
      fileName = path.split('/').pop().split('#')[0].split('?')[0].split('.EMB')[0].split('.emb')[0];
    }
    if (!fileName){
      return path || file;
    }
    return `${host}/storage/${fileName}`
  }
}